import axios from "axios";
import { getServiceURL } from "./utils";

const API = axios.create({
  baseURL: getServiceURL(),
});

export const LeadService = {
  submitLead: async (leadData) => {
    return API.post("/lead/submit", leadData);
  },

  getAllLeads: async () => {
    return API.get("/lead/getAll");
  },
};

export const DropdownOptionsService = {
  getCuisines: async () => {
    return API.get("/general/cuisines");
  },
  getUserRoles: async () => {
    return API.get("/general/user-roles");
  },
  getUserPermissions: async () => {
    return API.get("/general/user-permissions");
  },
};

export const CommonService = {
  generateQR: async (type, data) => {
    console.log(data);
    return API.post(`/common/generate-qr/${type}`, data, {
      responseType: "arraybuffer",
    });
  },
};

export const AuthService = {
  loginWithEmail: async (email) => {
    return API.post("/user/login", { contact: email });
  },

  superAdminLogin: async (email) => {
    return API.post("/user/superadmin-login", { email });
  },

  verifyOTP: async (email, otp) => {
    return API.post("/user/verify", { contact: email, otp });
  },

  superAdminVerifyOTP: async (email, otp) => {
    return API.post("/user/superadmin-verify", { email, otp });
  },
};

export const UserService = {
  createUser: async (data) => {
    return API.post("/user", data);
  },

  getAllUsersByRestaurantId: async (id) => {
    return API.get(`/user/${id}`);
  },

  getUserById: async (id) => {
    return API.get(`/user/${id}`);
  },

  updateUser: async (id, data) => {
    return API.put(`/user/${id}`, data);
  },

  deleteUser: async (id) => {
    return API.delete(`/user/${id}`);
  },
};

export const TableService = {
  createTable: async (data) => {
    return API.post("/tables", data);
  },

  getAllTablesByRestaurantId: async (id) => {
    return API.get(`/tables/all/${id}`);
  },

  getTableById: async (id) => {
    return API.get(`/tables/${id}`);
  },

  updateTable: async (id, data) => {
    return API.put(`/tables/${id}`, data);
  },

  deleteTable: async (id) => {
    return API.delete(`/tables/${id}`);
  },
};

export const MenuService = {
  createMenuItem: async (formData) => {
    return API.post("/menus", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  getAllMenuItems: async (id) => {
    return API.get(`/menus/all/${id}`);
  },

  getMenuItemById: async (id) => {
    return API.get(`/menus/${id}`);
  },

  updateMenuItem: async (id, data) => {
    return API.put(`/menus/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  deleteMenuItem: async (id) => {
    return API.delete(`/menus/${id}`);
  },
};

export const RestaurantService = {
  createRestaurant: async (formData) => {
    return API.post("/restaurants", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  changeLogo: async (restaurantId, formData) => {
    return API.put(`/restaurants/${restaurantId}/change-logo`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  getAllRestaurants: async () => {
    return API.get("/restaurants");
  },

  getRestaurantById: async (restaurantId) => {
    return API.get(`/restaurants/${restaurantId}`);
  },

  updateRestaurant: async (restaurantId, data) => {
    return API.put(`/restaurants/${restaurantId}`, data);
  },

  updateRestaurant_Admin: async (restaurantId, data) => {
    return API.put(`/restaurants/admin/${restaurantId}`, data);
  },

  deleteRestaurant: async (restaurantId) => {
    return API.delete(`/restaurants/${restaurantId}`);
  },
};

export const PaymentService = {
  addPaymentQR: async (formData, restaurantId) => {
    return API.post(`/payments/uploadQR/${restaurantId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  getPaymentQR: async (restaurantId) => {
    return API.get(`/payments/checkQR/${restaurantId}`);
  },
  changePaymentQR: async (formData, restaurantId) => {
    return API.put(`/payments/update/${restaurantId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

export const BannerService = {
  uploadBanner: async (restaurantId, formData) => {
    return API.post(`/banners/${restaurantId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  getAllBannersByRestaurantId: async (restaurantId) => {
    return API.get(`/banners/all/${restaurantId}`);
  },

  deleteBanner: async (bannerId) => {
    return API.delete(`/banners/${bannerId}`);
  },
};

export const OrderService = {
  getAllOrders: async (restaurantId) => {
    return API.get(`/orders/all/${restaurantId}`);
  },

  getOrderById: async (id) => {
    return API.get(`/orders/${id}`);
  },

  updateOrder: async (id, data) => {
    return API.put(`/orders/${id}`, data);
  },
};

export const SubscriptionService = {
  createSubscription: async (data) => {
    return API.post(`/subscription`, data);
  },

  getCurrentSubscription: async (restaurantId) => {
    return API.get(`/subscription/${restaurantId}`);
  },

  getAllSubscriptions: async () => {
    return API.get(`/subscription`);
  },

  cancelSubscription: async (subscriptionId) => {
    return API.put(`/subscription/cancel/${subscriptionId}`);
  },
};
